module.exports = __webpack_public_path__ + "img/bootstrap-logo.7e0c7538.png";